export default function actions() {
  $(document).on('click', '.document-template-var-copy-to-clipboard', (e) => {
    e.preventDefault();
    navigator.clipboard.writeText($(e.target).data('copy-clipboard'));
    $('.alert').fadeIn(1000);
    $('.alert').delay(3200).fadeOut(1000);
  });
}
